<template>
  <div class="c-subCategoryListUseScenes">
    <div class="c-subCategoryListUseScenes_inner">
      <h3 class="c-subCategoryListUseScenes_headline">
        <span class="c-subCategoryListUseScenes_headlineLink">
          <img
            class="c-subCategoryListUseScenes_headlineIcon"
            src="~/assets/images/common/category/icon/use-scenes.svg"
            alt=""
            aria-hidden="true"
            loading="lazy"
          >
          <span class="c-subCategoryListUseScenes_headlineText">人気のご利用シーン</span>
        </span>
      </h3>
      <ul class="c-subCategoryListUseScenes_list">
        <li
          class="c-subCategoryListUseScenes_listItem"
          v-for="(useScene, index) in useScenesList"
          :key="`useScene_${index}`"
        >
          <a
            class="c-subCategoryListUseScenes_listItemLink"
            :href="useScene.url"
          >
            {{ useScene.linkText }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

/** @type {import('vue').ComponentOptions} */
const subCategoryListUseScenes = {
  name: 'SubCategoryListUseScenes',
  computed: {
    ...mapState('master', ['useScenesList'])
  }
}
export default subCategoryListUseScenes
</script>

<style lang="scss" scoped>
.c-subCategoryListUseScenes {
  padding-left: 15px;
  &_inner {
    position: relative;
    z-index: z(dropdown-upper, content);
    padding: 16px 24px;
    width: 536px;
    border: 1px solid $color-gray-300;
    border-radius: 6px;
    background-color: $color-white;
    &::after {
      position: absolute;
      top: 64px;
      left: -14px;
      z-index: z(dropdown-upper, arrow);
      width: 14px;
      height: 15px;
      content: url('~assets/images/components/HomeMainContent/CategoryList/subcategory-box-tri.png');
      transform: scaleX(-1);
    }
  }
  &_headlineLink {
    position: relative;
    display: flex;
    color: $color-gray-900;
    font-weight: bold;
    font-size: 16px;
  }
  &_headlineIcon {
    max-width: none;
    height: 26px;
  }
  &_headlineText {
    margin-left: 6px;

    align-self: center;
  }
  &_list {
    display: flex;
    margin-top: 16px;

    flex-wrap: wrap;
  }
  &_listItem {
    width: 50%;
    &-first {
      order: -1;
    }
  }
  &_listItemLink {
    @include link-effect;

    display: block;
    color: $color-gray-900;
    font-size: 13px;
    line-height: 28px;
  }
}
</style>
